import { Config } from '@catalogo/core-configuration';
import { eventData } from '../../../listen';
import getDefaultEventPayload from '../default-event';
import { PageLoadEvent } from '../../../types/events';

export const eventTrack = (events: eventData, config: Config): void => {
  const pageload = events['page:load'][0] as PageLoadEvent;
  const track = events['event:track'][0];
  const { event = 'c:click', category = 'metrics', action, label } = track.detail;

  const defaultEvent = getDefaultEventPayload(pageload, config);
  const e = {
    event: event,
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
  };

  window.dataLayer = window.dataLayer || [{}];
  window.dataLayer.push({ ...defaultEvent, ...e });
};
